import UserService from "./UserService";
import Kichiri from "./KichiriService";
import { callRouteThatExplainsItsRefusals } from "./apiFetch";

const QboService = {
	/**
	 * Fetches the list of all authenticated QBO companies (realms), fetching each company name from QBO.
	 * @returns {Promise<Object>} The QBO companies response array.
	 */
	async getCompanies() {
		const userData = UserService.getUserData();
		try {
			const response = await Kichiri.integration.qboCompanies({}, {}, userData.authToken);
			return response;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Fetches the list of customers for a given QBO company using the realm ID.
	 * @param {Object} params
	 * @param {string} params.realmId - The QBO company realm ID.
	 * @returns {Promise<Object>} The QBO customers response.
	 */
	async getCustomers({ realmId }) {
		const userData = UserService.getUserData();
		try {
			const response = await Kichiri.integration.qboCustomers({ realmId }, {}, userData.authToken);
			return response;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Maps a Workflow client to a QBO company.
	 * @param {Object} params
	 * @param {string} params.workflowClientId - The Workflow client ID to map.
	 * @param {string} params.realmId - The QBO company realm ID.
	 * @returns {Promise<Object>} The mapping response.
	 */
	async mapClient({ workflowClientId, realmId }) {
		const userData = UserService.getUserData();
		try {
			const response = await Kichiri.integration.qboMapClient({}, { workflowClientId, realmId }, userData.authToken);
			return response;
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Whether a client is connected to a QuickBooks Online company, read from the same connection
	 * records the reconciliation tools and the trial balance pull use.
	 *
	 * @param {Object} params
	 * @param {Number} params.clientId
	 * @returns {Promise<Object>} { connected, realmId } or { error }
	 */
	async getClientConnection({ clientId }) {
		const connection = await callRouteThatExplainsItsRefusals({ path: "/integration/qbo/client_status", body: { clientId } });
		return connection;
	},

	/**
	 * A client's QuickBooks connection in one sentence for the Connections page: which company it
	 * is connected to, that it is not connected, or why that could not be checked — three different
	 * facts, said differently. Null while the answer has not arrived.
	 *
	 * @param {Object} params
	 * @param {Object|null} params.connection - from getClientConnection
	 * @returns {String|null}
	 */
	describeClientConnection({ connection }) {
		if (!connection) return null;
		if (connection.error) return `The QuickBooks connection could not be checked: ${connection.error}`;
		if (!connection.connected) return "Not connected — authorize QuickBooks below, then map this client to its company.";
		return `Connected to QuickBooks company ${connection.realmId}.`;
	},
};

export default QboService;
